import { HighContrastMode } from '../services/models/accesibility.model';

export class SetHighContrastMode {
  static readonly type = '[Accessibility] - Set high contrast mode';
  constructor(public readonly mode: HighContrastMode) {}
}

export class EnableHighContrast {
  static readonly type = '[Accessibility] - Enable high contrast';
  constructor(public readonly enable: boolean) {}
}
